import context from '../context'
import getComponentKey from '@/utils/getComponentKey'
import commonErrorHandler from '@/utils/errors'

const initialState = {
  gridKey: getComponentKey(),
  saving: false
}

const actionTypes = {
  Saving: 'inChargeOfInstitutions/saving',
  Saved: 'inChargeOfInstitutions/saved',
  Deleting: 'inChargeOfInstitutions/deleting',
  Deleted: 'inChargeOfInstitutions/deleted',
  Error: 'inChargeOfInstitutions/error'
}

const handleError = (details) => commonErrorHandler(actionTypes.Error, details)

export const actionCreators = {
  save: (input) => (dispatch, getState) => {
    dispatch({ type: actionTypes.Saving })
    context.api.individualInChargeOfInstitutionService.save(input)
      .then(response => {
        dispatch({ type: actionTypes.Saved })
      })
      .catch(error => handleError({ dispatch, error, update: { saving: false } }))
  },
  deleteEntity: (id) => (dispatch, getState) => {
    dispatch({ type: actionTypes.Deleting })
    context.api.individualInChargeOfInstitutionService.delete(id)
      .then(response => {
        dispatch({ type: actionTypes.Deleted })
      })
      .catch(error => handleError({ dispatch, error, update: { saving: false } }))
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.Saving: return { ...state, saving: true }
    case actionTypes.Saved: return { ...state, saving: false, gridKey: getComponentKey() }
    case actionTypes.Deleting: return { ...state, saving: true }
    case actionTypes.Deleted: return { ...state, saving: false, gridKey: getComponentKey() }
    case actionTypes.Error: return { ...state, ...action.data }

    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/store/InChargeOfInstitutions.js